import type { TabToggleProps } from './types';

function TabToggle<T extends string>({
  tabs,
  activeTab,
  onChange,
  ariaLabel,
  className = '',
}: TabToggleProps<T>) {
  return (
    <div
      role="tablist"
      aria-label={ariaLabel}
      className={`flex bg-[#ECEDF0] rounded-xl p-1 gap-1 w-full max-w-[432px] h-[48px] ${className}`}
    >
      {tabs.map((tab) => (
        <button
          key={tab.id}
          role="tab"
          type="button"
          data-testid={`tab-${tab.id}`}
          aria-selected={activeTab === tab.id}
          onClick={() => onChange(tab.id)}
          className={`flex-1 h-[40px] rounded-md text-titleMedium font-semibold whitespace-nowrap transition-all cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2A4455] ${
            activeTab === tab.id
              ? 'bg-white shadow-[0px_1px_2px_rgba(0,0,0,0.15),0px_2px_6px_2px_rgba(0,0,0,0.08)] text-[#2A4455]'
              : 'text-[#878b8e] hover:text-[#2A4455]'
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

export default TabToggle;
